import Glide from '@glidejs/glide';

const locationCardSliderHandler = () => {
    const locationSliders = document.querySelectorAll(".location-card-row__glide");

    locationSliders.forEach((slider, i) => {
        const autoplay = slider.dataset.autoplay;
        // Check if the slider has already been initialized
        if (!slider.hasAttribute('data-initialized')) {
            new Glide(slider, {
                type: 'carousel',
                startAt: 0,
                perView: 2,
                gap: 10,
                autoplay: Number(autoplay),
                breakpoints: {
                    640: { perView:  1},
                },
            }).mount();
            // Mark the slider as initialized
            slider.setAttribute('data-initialized', 'true');
        }
    });
};

if (document.readyState !== "loading") {
    locationCardSliderHandler();
} else {
    document.addEventListener("DOMContentLoaded", locationCardSliderHandler);
}